import { jsx as _jsx } from "react/jsx-runtime";
import { LogEntry } from './logEntry';
export const AutoreplySent = ({ entry }) => {
    const text = `Conversation autoreply sent with template ${entry.template_name}`;
    return _jsx(LogEntry, { entry: entry, text: text });
};
